import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {AccountRoutingModule} from './account-routing.module';
import {AccountComponent} from './account.component';
import {TranslateModule} from "@ngx-translate/core";
import {AngularSvgIconModule} from "angular-svg-icon";
import {AppBarModule} from "@app/presentation/components/app-bar/app-bar.module";
import {ButtonModule} from "@app/presentation/components/button/button.module";
import {DeleteAccountModule} from "@app/presentation/components/delete-account/delete-account.module";
import {LocalizeRouterModule} from "@gilsdav/ngx-translate-router";
import {SpaceModule} from "@app/presentation/components/space/space.module";
import {ShareServiceModule} from "@app/presentation/services/share/share-service.module";
import {LanguageSelectorService} from '@app/presentation/services/language-selector/language-selector.service';


@NgModule({
  declarations: [
    AccountComponent
  ],
    imports: [
        CommonModule,
        AccountRoutingModule,
        TranslateModule,
        AngularSvgIconModule,
        AppBarModule,
        ButtonModule,
        DeleteAccountModule,
        LocalizeRouterModule,
        SpaceModule,
        ShareServiceModule,
    ],
    providers: [LanguageSelectorService]
})
export class AccountModule { }
